'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const adventSplitSection = document.querySelectorAll('.js-advent-split');
const shouldInit = adventSplitSection.length > 0;

function adventTextSplit() {
    const circleAdvent = document.querySelector('.circle-advent');
    const paragraph = document.querySelector('.advent-split-text');
    const adventSplitSectionLetters = document.querySelectorAll('.advent-split-text');
    const fullText = paragraph.textContent;
    const wordsNum = fullText.length;
    const text = paragraph.textContent.split('');
    paragraph.innerText = '';

    for (let i = 0; i < text.length; i++) {
        const letter = `<span>${text[i]}</span>`;
        paragraph.innerHTML += letter;
    }

    const scrollObserver = new IntersectionObserver((blocks) => {
        for (const block of blocks) {
            if (block.isIntersecting && block.intersectionRatio >= 0.1 && block.boundingClientRect.y > 0) {
              const blockPerc = (block.target.dataset.perc) ? block.target.dataset.perc : 0;
              const perc = Math.round(block.intersectionRatio * 100);
              const perc3 = Math.round(block.intersectionRatio * 10) / 10;
              block.target.dataset.perc = Math.max(blockPerc, perc);
                paragraph.childNodes.forEach((letter, i) => {
                    if (i < wordsNum * perc3 && wordsNum * perc3 <= wordsNum) {
                        letter.classList.add('js-advent-letter');
                        letter.classList.add('advent-text-white');
                    } else {
                        letter.classList.remove('js-advent-letter');
                        letter.classList.remove('advent-text-white');
                    }
                });
            }
        }
    }, {
        threshold: [0, 0.01, 0.02, 0.03, 0.04, 0.05, 0.06, 0.07, 0.08, 0.09, 0.10, 0.11, 0.12, 0.13, 0.14, 0.15, 0.16, 0.17, 0.18, 0.19, 0.20, 0.21, 0.22, 0.23, 0.24, 0.25, 0.26, 0.27, 0.28, 0.29, 0.30, 0.31, 0.32, 0.33, 0.34, 0.35, 0.36, 0.37, 0.38, 0.39, 0.40, 0.41, 0.42, 0.43, 0.44, 0.45, 0.46, 0.47, 0.48, 0.49, 0.50, 0.51, 0.52, 0.53, 0.54, 0.55, 0.56, 0.57, 0.58, 0.59, 0.60, 0.61, 0.62, 0.63, 0.64, 0.65, 0.66, 0.67, 0.68, 0.69, 0.70, 0.71, 0.72, 0.73, 0.74, 0.75, 0.76, 0.77, 0.78, 0.79, 0.80, 0.81, 0.82, 0.83, 0.84, 0.85, 0.86, 0.87, 0.88, 0.89, 0.90, 0.91, 0.92, 0.93, 0.94, 0.95, 0.96, 0.97, 0.98, 0.99, 1]
    });

    adventSplitSectionLetters.forEach((el) => {
      scrollObserver.observe(el);
    });

    function elementsOverlap(elem1, elem2) {
        const dimensionsFirst = elem1.getBoundingClientRect();
        const dimensionsSecond = elem2.getBoundingClientRect();

        return !(
            dimensionsFirst.top > dimensionsSecond.bottom ||
            dimensionsFirst.right < dimensionsSecond.left ||
            dimensionsFirst.bottom < dimensionsSecond.top ||
            dimensionsFirst.left > dimensionsSecond.right
        );
    }

    if (!isSmallView()) {
        let mouseX = 0,
        mouseY = 0,
        circleX = 0,
        circleY = 0;

        $('.js-advent-split').on('mousemove', function(e) {
            mouseX = e.pageX;
            mouseY = e.pageY;

            circleX += ((mouseX - circleX) / 6);
            circleY += ((mouseY - circleY) / 6);

            const scrollLeft = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
            const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

            $('.circle-advent').css({
                left: circleX - scrollLeft - 250 + 'px',
                top: circleY - scrollTop - 250 + 'px'
            });

            paragraph.childNodes.forEach((letter) => {
                if (elementsOverlap(letter, circleAdvent) && letter.classList.contains('js-advent-letter')) {
                    letter.classList.add('advent-golden');
                } else {
                    letter.classList.remove('advent-golden');
                }
            });
        });
    }
}

function initializeEvents() {
    adventTextSplit();
}

const adventSplit = {
    init: function() {
        if (shouldInit) {
            initializeEvents();
        }
    }
};

module.exports = adventSplit;
